export default __webpack_public_path__ + "static/media/background_image1.6c7c6aef.jpg";